import { makeStyles } from '@material-ui/core/styles';

export const useConversationSearchModalStyles = makeStyles(theme => ({
  dialogPaper: {
    borderRadius: theme.shape.borderRadius,
    minHeight: '30dvh',
    maxHeight: '80dvh'
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between'
  },
  dialogContent: {
    padding: theme.spacing(2, 0)
  }
}));
